import React from 'react';
import { DisplayDateTime, DisplayDepth } from '../Display';

interface IProps {
  startDate: string;
  duration: string;
  maxDepth: number;
  averageDepth: number;
  diveName?: string;
}

const DEFAULT_DIVE_NAME = 'Dive data';

const DiveDataHeader = (props: IProps) => {
  const {
    diveName = DEFAULT_DIVE_NAME,
    duration,
    startDate,
    maxDepth,
    averageDepth,
  } = props;

  return (
    <div className="standardContainer__header cf withTabs">
      <div className="tabs">
        <div className="tab tabHeader">
          <h3>{diveName}</h3>
        </div>
        <div className="tab tabValues">
          <div className="tab tab--value tab--date">
            <p>Date and time</p>
            <span>
              <DisplayDateTime data={startDate} />
            </span>
          </div>
          <div className="tab tab--value tab--time">
            <p>Dive time</p>
            <span>{duration}</span>
          </div>
          <div className="tab tab--value tab--maxDepth">
            <p>Max depth</p>
            <span>
              <DisplayDepth data={maxDepth} />
            </span>
          </div>
          <div className="tab tab--value tab--averageDepth">
            <p>Average depth</p>
            <span>
              <DisplayDepth data={averageDepth} />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiveDataHeader;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DiveDataHeader/DiveDataHeader.tsx